import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  organizationDetails,
  organizationListFront,
} from "../../services/organizationService";

const hasSessionStorage = sessionStorage.getItem("organization");

const initialState = {
  selectedOrganization: hasSessionStorage
    ? hasSessionStorage
    : localStorage.getItem("organization") || null,
  organizations: { data: null, loading: true, error: null },
  selectedOrganizationDetails: {
    data: null,
    loading: true,
    error: null,
  },
};

export const getOrganizationList = createAsyncThunk(
  "organization/getOrganizationList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await organizationListFront({ status: "active" });
      if (res?.docs?.status !== 200) {
        return rejectWithValue(res?.message || "Failed to fetch organizations");
      }
      return res?.docs;
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

export const getOrganizationDetails = createAsyncThunk(
  "organization/getOrganizationDetails",
  async (id, { rejectWithValue }) => {
    try {
      const res = await organizationDetails({ id });
      if (res?.status !== 200) {
        return rejectWithValue(
          res?.message || "Failed to fetch organization details"
        );
      }
      return res?.data;
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganization: (state, action) => {
      state.selectedOrganization = action.payload;
      sessionStorage.setItem("organization", action.payload);
      localStorage.setItem("organization", action.payload);
    },
    setOrganizations: (state, action) => {
      state.organizations.data = action.payload;
    },
    setOrganizationDetails: (state, action) => {
      state.selectedOrganizationDetails.data = action.payload;
    },
    resetOrganization: (state, action) => {
      state.selectedOrganization = null;
      state.organizations = { data: null, loading: true, error: null };
      state.selectedOrganizationDetails = {
        data: null,
        loading: true,
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationList.pending, (state) => {
        state.organizations.loading = true;
        state.organizations.error = null;
      })
      .addCase(getOrganizationList.fulfilled, (state, action) => {
        state.organizations.loading = false;
        state.organizations.data = action.payload;
        state.selectedOrganization = hasSessionStorage
          ? hasSessionStorage
          : localStorage.getItem("organization") ||
            action?.payload?.data?.[0]?.organizationData?._id ||
            null;
      })
      .addCase(getOrganizationList.rejected, (state, action) => {
        state.organizations.loading = false;
        state.organizations.error = action.payload;
      })
      // =========================================================================>
      .addCase(getOrganizationDetails.pending, (state) => {
        state.selectedOrganizationDetails.loading = true;
        state.selectedOrganizationDetails.error = null;
      })
      .addCase(getOrganizationDetails.fulfilled, (state, action) => {
        state.selectedOrganizationDetails.loading = false;
        state.selectedOrganizationDetails.data = action.payload;
      })
      .addCase(getOrganizationDetails.rejected, (state, action) => {
        state.selectedOrganizationDetails.loading = false;
        state.selectedOrganizationDetails.error = action.payload;
      });
  },
});

export const {
  setOrganization,
  resetOrganization,
  setOrganizations,
  setOrganizationDetails,
} = organizationSlice.actions;
export default organizationSlice.reducer;
